(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseFallbacks(root) {
    return {
      days: root.dataset.defaultDays || '08',
      hours: root.dataset.defaultHours || '10',
      minutes: root.dataset.defaultMinutes || '54',
      seconds: root.dataset.defaultSeconds || '22'
    };
  }

  function setValues(root, values) {
    var units = root.querySelectorAll('[data-wc-unit]');
    units.forEach(function (item) {
      var unit = item.getAttribute('data-wc-unit');
      if (values[unit] !== undefined) item.textContent = values[unit];
    });
  }

  var US_WEEKDAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function getZonedDateParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
    var parts = formatter.formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    var hour = Number(values.hour);
    if (hour === 24) hour = 0;

    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day),
      weekday: values.weekday,
      hour: hour,
      minute: Number(values.minute),
      second: Number(values.second)
    };
  }

  function getTimezoneOffsetMs(date, timeZone) {
    var parts = getZonedDateParts(date, timeZone);
    var asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return asUtc - date.getTime();
  }

  function zonedTimeToUtc(year, month, day, hour, minute, second, timeZone) {
    var utcGuess = Date.UTC(year, month - 1, day, hour, minute, second);
    var date = new Date(utcGuess);
    return new Date(utcGuess - getTimezoneOffsetMs(date, timeZone));
  }

  function addCalendarDays(year, month, day, days) {
    var date = new Date(Date.UTC(year, month - 1, day + days));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    };
  }

  function getWeeklyUsCycleEndDate(now, timeZone) {
    var parts = getZonedDateParts(now, timeZone);
    var dayOfWeek = US_WEEKDAY_MAP[parts.weekday];
    var daysUntil;

    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      daysUntil = 6 - dayOfWeek;
    } else if (dayOfWeek === 6) {
      daysUntil = 2;
    } else {
      daysUntil = 1;
    }

    var targetDate = addCalendarDays(parts.year, parts.month, parts.day, daysUntil);
    return zonedTimeToUtc(targetDate.year, targetDate.month, targetDate.day, 0, 0, 0, timeZone);
  }

  function resolveCountdownEndDate(block) {
    if (block.hasAttribute('data-countdown-weekly-us-cycle')) {
      var timeZone = block.dataset.countdownTimezone || 'America/Los_Angeles';
      return getWeeklyUsCycleEndDate(new Date(), timeZone);
    }

    var endAt = block.dataset.countdownEnd;
    if (!endAt) return null;

    var endDate = new Date(endAt);
    return Number.isNaN(endDate.getTime()) ? null : endDate;
  }

  function initCountdownBlock(block) {
    if (!block) return;

    if (block._wcTimer) {
      clearInterval(block._wcTimer);
      block._wcTimer = null;
    }

    var fallbacks = parseFallbacks(block);
    setValues(block, fallbacks);

    var isWeeklyCycle = block.hasAttribute('data-countdown-weekly-us-cycle');
    if (!isWeeklyCycle && !block.dataset.countdownEnd) return;

    function tick() {
      var endDate = resolveCountdownEndDate(block);
      if (!endDate) return;

      var diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        if (isWeeklyCycle) {
          setValues(block, { days: '00', hours: '00', minutes: '00', seconds: '00' });
          return;
        }

        clearInterval(block._wcTimer);
        block._wcTimer = null;
        setValues(block, { days: '00', hours: '00', minutes: '00', seconds: '00' });
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      setValues(block, {
        days: pad(days),
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds)
      });
    }

    tick();
    block._wcTimer = setInterval(tick, 1000);
  }

  function initBanner(root) {
    if (!root) return;
    var countdownBlocks = root.querySelectorAll('[data-wc-countdown]');
    countdownBlocks.forEach(initCountdownBlock);
  }

  function initAllWcBanners() {
    var banners = document.querySelectorAll('[data-wc-banner]');
    banners.forEach(initBanner);
  }

  document.addEventListener('DOMContentLoaded', initAllWcBanners);
  document.addEventListener('shopify:section:load', initAllWcBanners);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    var banner = event.target.querySelector('[data-wc-banner]');
    if (!banner) return;
    var countdownBlocks = banner.querySelectorAll('[data-wc-countdown]');
    countdownBlocks.forEach(function (block) {
      if (block._wcTimer) {
        clearInterval(block._wcTimer);
        block._wcTimer = null;
      }
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    if (!event || !event.target) return;
    if (event.target.hasAttribute('data-wc-countdown')) {
      initCountdownBlock(event.target);
    }
  });
})();
